/**
 * @generated SignedSource<<051e32fbd98ad001316d67f7967402ee>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
export type EventSlotType = "BUFFER" | "EVENT";
export type RestrictionMemberVisibility = "NONE" | "RESTRICTION_ONLY" | "SLOTS_AND_RESTRICTION" | "SLOTS_AND_RESTRICTION_INLINE" | "SLOTS_ONLY";
export type SlotAvailability = "ACCESSIBLE" | "ACCESSIBLE_BOOKING" | "AVAILABLE" | "AVAILABLE_AFTER_START" | "BLOCKED" | "BLOCKED_BY_BLOCK" | "BLOCKED_BY_BOOKING" | "BLOCKED_BY_EVENT" | "FREE" | "UNAVAILABLE";
import { FragmentRefs } from "relay-runtime";
export type SingleCourseColumn_course$data = {
  readonly facility: {
    readonly club: {
      readonly supportsPublic: boolean;
    } | null | undefined;
    readonly id: string;
    readonly " $fragmentSpreads": FragmentRefs<"getFacilityMemberPermissions_facility">;
  };
  readonly id: string;
  readonly name: string;
  readonly timeSlots: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly availability: SlotAvailability;
        readonly block: {
          readonly blockSeries: {
            readonly isVisibleToMembers: boolean;
          };
          readonly id: string;
          readonly " $fragmentSpreads": FragmentRefs<"BlockSlot_block">;
        } | null | undefined;
        readonly bookingRestrictions: {
          readonly edges: ReadonlyArray<{
            readonly liftAt: string | null | undefined;
            readonly node: {
              readonly id: string;
              readonly name: string;
              readonly visibility?: RestrictionMemberVisibility | null | undefined;
            } | null | undefined;
          } | null | undefined> | null | undefined;
        } | null | undefined;
        readonly bookings: {
          readonly edges: ReadonlyArray<{
            readonly node: {
              readonly bufferSlots?: {
                readonly count: number;
              } | null | undefined;
              readonly id: string;
              readonly slots: {
                readonly count: number;
                readonly edges: ReadonlyArray<{
                  readonly node: {
                    readonly id: string;
                  } | null | undefined;
                } | null | undefined> | null | undefined;
              } | null | undefined;
              readonly startSlot: {
                readonly id: string;
              } | null | undefined;
              readonly " $fragmentSpreads": FragmentRefs<"BookingSlot_booking">;
            } | null | undefined;
          } | null | undefined> | null | undefined;
        } | null | undefined;
        readonly configuredRequestRestrictions?: {
          readonly edges: ReadonlyArray<{
            readonly liftAt: string | null | undefined;
            readonly node: {
              readonly id: string;
              readonly memberVisibility?: RestrictionMemberVisibility | null | undefined;
              readonly requestConfig?: {
                readonly id: string;
              } | null | undefined;
            } | null | undefined;
            readonly requestCloses: string | null | undefined;
            readonly requestOpens: string | null | undefined;
          } | null | undefined> | null | undefined;
        } | null | undefined;
        readonly dateTime: string | null | undefined;
        readonly eventSlot: {
          readonly eventSession: {
            readonly bufferMinsAfter: number | null | undefined;
            readonly bufferMinsBefore: number | null | undefined;
            readonly id: string;
            readonly " $fragmentSpreads": FragmentRefs<"EventSlot_eventSession">;
          };
          readonly id: string;
          readonly type: EventSlotType;
        } | null | undefined;
        readonly hasSplitBooking: boolean;
        readonly id: string;
        readonly requestRestrictions?: {
          readonly edges: ReadonlyArray<{
            readonly liftAt: string | null | undefined;
            readonly node: {
              readonly id: string;
            } | null | undefined;
          } | null | undefined> | null | undefined;
        } | null | undefined;
        readonly time: string;
      } | null | undefined;
    } | null | undefined> | null | undefined;
  } | null | undefined;
  readonly " $fragmentType": "SingleCourseColumn_course";
};
export type SingleCourseColumn_course$key = {
  readonly " $data"?: SingleCourseColumn_course$data;
  readonly " $fragmentSpreads": FragmentRefs<"SingleCourseColumn_course">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "supportsPublic",
  "storageKey": null
},
v3 = [
  (v0/*: any*/),
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "isFacilityVisible",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "isFacilityBookable",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "areOtherBookingsVisible",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "areOtherBookingsJoinable",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "canBookOnBusySlot",
    "storageKey": null
  }
],
v4 = [
  (v0/*: any*/)
],
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "count",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "concreteType": null,
  "kind": "LinkedField",
  "name": "node",
  "plural": false,
  "selections": (v4/*: any*/),
  "storageKey": null
},
v7 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "TimeSlotConnection",
    "kind": "LinkedField",
    "name": "bufferSlots",
    "plural": false,
    "selections": [
      (v5/*: any*/)
    ],
    "storageKey": null
  }
],
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "liftAt",
  "storageKey": null
},
v9 = [
  {
    "kind": "Literal",
    "name": "type",
    "value": [
      "REQUEST"
    ]
  }
];
return {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "date"
    },
    {
      "kind": "RootArgument",
      "name": "requestConfigs"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "SingleCourseColumn_course",
  "selections": [
    (v0/*: any*/),
    (v1/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "Facility",
      "kind": "LinkedField",
      "name": "facility",
      "plural": false,
      "selections": [
        (v0/*: any*/),
        {
          "kind": "InlineDataFragmentSpread",
          "name": "getFacilityMemberPermissions_facility",
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "Club",
              "kind": "LinkedField",
              "name": "club",
              "plural": false,
              "selections": [
                (v0/*: any*/),
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "supportsPrivate",
                  "storageKey": null
                },
                (v2/*: any*/)
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "PublicBookingPermissionSet",
              "kind": "LinkedField",
              "name": "publicBookingPermissionSet",
              "plural": false,
              "selections": (v3/*: any*/),
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "PrivateBookingPermissionSet",
              "kind": "LinkedField",
              "name": "privateBookingPermissionSet",
              "plural": false,
              "selections": (v3/*: any*/),
              "storageKey": null
            }
          ],
          "args": null,
          "argumentDefinitions": []
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "Club",
          "kind": "LinkedField",
          "name": "club",
          "plural": false,
          "selections": [
            (v2/*: any*/)
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": [
        {
          "kind": "Variable",
          "name": "dateGte",
          "variableName": "date"
        },
        {
          "kind": "Variable",
          "name": "dateLte",
          "variableName": "date"
        },
        {
          "kind": "Literal",
          "name": "first",
          "value": 10000
        }
      ],
      "concreteType": "TimeSlotConnection",
      "kind": "LinkedField",
      "name": "timeSlots",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "TimeSlotEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "TimeSlot",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                (v0/*: any*/),
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "availability",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "hasSplitBooking",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "time",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "dateTime",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "BookingConnection",
                  "kind": "LinkedField",
                  "name": "bookings",
                  "plural": false,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "BookingEdge",
                      "kind": "LinkedField",
                      "name": "edges",
                      "plural": true,
                      "selections": [
                        {
                          "alias": null,
                          "args": null,
                          "concreteType": null,
                          "kind": "LinkedField",
                          "name": "node",
                          "plural": false,
                          "selections": [
                            {
                              "args": null,
                              "kind": "FragmentSpread",
                              "name": "BookingSlot_booking"
                            },
                            (v0/*: any*/),
                            {
                              "alias": null,
                              "args": null,
                              "concreteType": null,
                              "kind": "LinkedField",
                              "name": "startSlot",
                              "plural": false,
                              "selections": (v4/*: any*/),
                              "storageKey": null
                            },
                            {
                              "alias": null,
                              "args": null,
                              "concreteType": "SlotConnection",
                              "kind": "LinkedField",
                              "name": "slots",
                              "plural": false,
                              "selections": [
                                (v5/*: any*/),
                                {
                                  "alias": null,
                                  "args": null,
                                  "concreteType": "SlotEdge",
                                  "kind": "LinkedField",
                                  "name": "edges",
                                  "plural": true,
                                  "selections": [
                                    (v6/*: any*/)
                                  ],
                                  "storageKey": null
                                }
                              ],
                              "storageKey": null
                            },
                            {
                              "kind": "InlineFragment",
                              "selections": (v7/*: any*/),
                              "type": "StandardBooking",
                              "abstractKey": null
                            },
                            {
                              "kind": "InlineFragment",
                              "selections": (v7/*: any*/),
                              "type": "LessonBooking",
                              "abstractKey": null
                            }
                          ],
                          "storageKey": null
                        }
                      ],
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "TimeSlotBlock",
                  "kind": "LinkedField",
                  "name": "block",
                  "plural": false,
                  "selections": [
                    (v0/*: any*/),
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "BlockSeries",
                      "kind": "LinkedField",
                      "name": "blockSeries",
                      "plural": false,
                      "selections": [
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "isVisibleToMembers",
                          "storageKey": null
                        }
                      ],
                      "storageKey": null
                    },
                    {
                      "args": null,
                      "kind": "FragmentSpread",
                      "name": "BlockSlot_block"
                    }
                  ],
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "EventSlot",
                  "kind": "LinkedField",
                  "name": "eventSlot",
                  "plural": false,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "type",
                      "storageKey": null
                    },
                    (v0/*: any*/),
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "EventSession",
                      "kind": "LinkedField",
                      "name": "eventSession",
                      "plural": false,
                      "selections": [
                        (v0/*: any*/),
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "bufferMinsAfter",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "bufferMinsBefore",
                          "storageKey": null
                        },
                        {
                          "args": null,
                          "kind": "FragmentSpread",
                          "name": "EventSlot_eventSession"
                        }
                      ],
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                },
                {
                  "alias": "bookingRestrictions",
                  "args": [
                    {
                      "kind": "Literal",
                      "name": "bookingType",
                      "value": [
                        "STANDARD"
                      ]
                    },
                    {
                      "kind": "Literal",
                      "name": "isBlocking",
                      "value": true
                    },
                    {
                      "kind": "Literal",
                      "name": "type",
                      "value": [
                        "RESTRICTION"
                      ]
                    }
                  ],
                  "concreteType": "SlotBookingRulesConnection",
                  "kind": "LinkedField",
                  "name": "bookingRules",
                  "plural": false,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "SlotBookingRulesEdge",
                      "kind": "LinkedField",
                      "name": "edges",
                      "plural": true,
                      "selections": [
                        (v8/*: any*/),
                        {
                          "alias": null,
                          "args": null,
                          "concreteType": null,
                          "kind": "LinkedField",
                          "name": "node",
                          "plural": false,
                          "selections": [
                            (v0/*: any*/),
                            (v1/*: any*/),
                            {
                              "kind": "InlineFragment",
                              "selections": [
                                {
                                  "alias": "visibility",
                                  "args": null,
                                  "kind": "ScalarField",
                                  "name": "memberVisibility",
                                  "storageKey": null
                                }
                              ],
                              "type": "BookingRestrictionRule",
                              "abstractKey": null
                            }
                          ],
                          "storageKey": null
                        }
                      ],
                      "storageKey": null
                    }
                  ],
                  "storageKey": "bookingRules(bookingType:[\"STANDARD\"],isBlocking:true,type:[\"RESTRICTION\"])"
                },
                {
                  "condition": "requestConfigs",
                  "kind": "Condition",
                  "passingValue": false,
                  "selections": [
                    {
                      "alias": "requestRestrictions",
                      "args": (v9/*: any*/),
                      "concreteType": "SlotBookingRulesConnection",
                      "kind": "LinkedField",
                      "name": "bookingRules",
                      "plural": false,
                      "selections": [
                        {
                          "alias": null,
                          "args": null,
                          "concreteType": "SlotBookingRulesEdge",
                          "kind": "LinkedField",
                          "name": "edges",
                          "plural": true,
                          "selections": [
                            (v8/*: any*/),
                            (v6/*: any*/)
                          ],
                          "storageKey": null
                        }
                      ],
                      "storageKey": "bookingRules(type:[\"REQUEST\"])"
                    }
                  ]
                },
                {
                  "condition": "requestConfigs",
                  "kind": "Condition",
                  "passingValue": true,
                  "selections": [
                    {
                      "alias": "configuredRequestRestrictions",
                      "args": (v9/*: any*/),
                      "concreteType": "SlotBookingRulesConnection",
                      "kind": "LinkedField",
                      "name": "requestWindowBookingRules",
                      "plural": false,
                      "selections": [
                        {
                          "alias": null,
                          "args": null,
                          "concreteType": "SlotBookingRulesEdge",
                          "kind": "LinkedField",
                          "name": "edges",
                          "plural": true,
                          "selections": [
                            (v8/*: any*/),
                            {
                              "alias": null,
                              "args": null,
                              "kind": "ScalarField",
                              "name": "requestOpens",
                              "storageKey": null
                            },
                            {
                              "alias": null,
                              "args": null,
                              "kind": "ScalarField",
                              "name": "requestCloses",
                              "storageKey": null
                            },
                            {
                              "alias": null,
                              "args": null,
                              "concreteType": null,
                              "kind": "LinkedField",
                              "name": "node",
                              "plural": false,
                              "selections": [
                                (v0/*: any*/),
                                {
                                  "kind": "InlineFragment",
                                  "selections": [
                                    {
                                      "alias": null,
                                      "args": null,
                                      "kind": "ScalarField",
                                      "name": "memberVisibility",
                                      "storageKey": null
                                    },
                                    {
                                      "alias": null,
                                      "args": null,
                                      "concreteType": "RequestConfig",
                                      "kind": "LinkedField",
                                      "name": "requestConfig",
                                      "plural": false,
                                      "selections": (v4/*: any*/),
                                      "storageKey": null
                                    }
                                  ],
                                  "type": "RequestRule",
                                  "abstractKey": null
                                }
                              ],
                              "storageKey": null
                            }
                          ],
                          "storageKey": null
                        }
                      ],
                      "storageKey": "requestWindowBookingRules(type:[\"REQUEST\"])"
                    }
                  ]
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Course",
  "abstractKey": null
};
})();

(node as any).hash = "cc10afbdaab335cbccc68745278ac192";

export default node;
